import { Avatar } from "@progress/kendo-react-layout";
import { useNavigate } from "react-router-dom";
import UserLogo from "../../assets/Images/useravatar.jpg";
import React from "react";
import IconComponent from "../common/IconComponent";
import { RiLogoutCircleRLine } from "react-icons/ri";
const UserProfile = () => {
  const navigate = useNavigate();
  const UserName = localStorage.getItem("UserName");

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
    setIsMenuOpen(false);
  };
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const handleMenuClick = () => {
    setIsMenuOpen((prev) => !prev);
  };

  React.useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (!event.target.closest(".userprofile")) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <>
      <div className="userprofile position-relative" onClick={handleMenuClick}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div
            style={{
              display: "flex",
              alignItems: "end",
              flexDirection: "column",
              color: "#fff",
              minWidth: "150px",
              marginRight: "10px",
            }}
          >
            <strong>{UserName || ""}</strong>
            {/* <strong style={{ fontSize: 14, fontWeight: 600 }}>
              {loginDetails?.UserType || ""}
            </strong> */}
          </div>
          <Avatar
            className="userprofile-avatar"
            type="image"
            size="medium"
            style={{ width: 40, height: 40, borderRadius: "50%", flex: 1 }}
          >
            <img
              src={
                // loginDetails?.UserImage && loginDetails?.UserImage !== "null"
                //   ? loginDetails?.UserImage
                //   :
                UserLogo
              }
              alt={`user image`}
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
              }}
            />
          </Avatar>

          {/* <Avatar size={40} gap={0} icon={} /> */}
        </div>
        {isMenuOpen && (
          <div
            style={{
              borderRadius: "10px",
              position: "absolute",
              bottom: "-48px",
              left: "0px",
              width: "100%",
              height: "fit-content",
              background: "white",
              padding: "10px",
              border: "1px solid whitesmoke",
              boxShadow: "0 0 10px #0000001c",
              color: "red",
            }}
            onClick={handleLogout}
          >
            <IconComponent icon={RiLogoutCircleRLine} /> &nbsp;Log Out
          </div>
        )}
      </div>
    </>
  );
};

export default UserProfile;
